export default __webpack_public_path__ + "static/media/preloader.9c7cd866.gif";